<template>
  <v-card class="" outlined>
    <v-toolbar
        color="#488ba6"
        dark
        outlined
    >
      <v-toolbar-title>{{ state.member.meeting.meetingInfo.name }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <p>If you are a new registrant for the {{ state.member.meeting.meetingInfo.name }} choose the option: "I would
        like to
        register for the upcoming FVS Annual Meeting". </p>
      <p>If you are previously registered for the Annual meeting and you
        would like to: </p>
      <ul>
        <li>Add more special event tickets.</li>
        <li>Make a donation to the Florida Vascular Society.</li>
        <li>Check to see what you have registered for.</li>
      </ul>
      <br>
      <p>Select the "I am already registered for the upcoming FVS
        Annual Meeting and I would like to add more products or tickets to my registration".</p>
      <v-form>
        <v-row v-if="!state.member.meeting.previouslyRegistered.meetingID">
          <v-col class="registration-column"
              lg="12"
              xs="12"
          >
            <v-select
                :items="prevRegisteredOptions"
                label="Please select an option below and then click continue"
                item-text="text"
                attach
                item-value="val"
                v-model="state.member.meeting.previouslyRegistered.isRegistered"
            ></v-select>
          </v-col>

          <v-col class="registration-column"
              v-if="state.member.meeting.previouslyRegistered.isRegistered === true"
              lg="4"
              md="4"
              xs="12"
          >
            <v-text-field
                label="Please enter the email address you registered with"
                name="lkp-email"
                type="text"
                v-model="state.member.meeting.previouslyRegistered.enteredMeetingEmail"
            ></v-text-field>
          </v-col>
          <v-col
              lg="4"
              xs="12"
          >
            <v-btn v-if="showContinueBtn" color="#488ba6" @click="findRegistration" style="color:white;margin-top:12px">
              Continue
            </v-btn>
          </v-col>
          <v-col
              lg="12"
              xs="12"
          >
            <v-alert class="mt-2" type="error" v-if="state.member.meeting.previouslyRegistered.attempted">
              <small>Unable to locate registration with the provided email, please try again.</small>

            </v-alert>
          </v-col>
        </v-row>


        <LookupVerify v-if="state.member.meeting.previouslyRegistered.meetingID"/>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>

import {mapGetters} from 'vuex'
import LookupVerify from "@/components/update-registration/LookupVerify";

export default {
  data: function () {
    return {
      prevRegisteredOptions: [
        {
          text: '',
          val: 'choose'
        },
        {
          text: 'I am already registered for the upcoming FVS Annual Meeting and I would like to add more products or tickets to my registration',
          val: true
        },
        {
          text: 'I would like to register for the upcoming FVS Annual Meeting',
          val: false
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      state: 'getState',
    }),
    showContinueBtn: function () {
      let out = false;

      out = !(this.state.member.meeting.previouslyRegistered.isRegistered
          && !this.state.member.meeting.previouslyRegistered.enteredMeetingEmail);

      return out;
    }
  },
  methods: {
    findRegistration() {
      if (this.state.member.meeting.previouslyRegistered.isRegistered) {
        this.$store.dispatch("getPreviousRegistration");
      } else {
        this.$store.commit('editOrder');
      }

    }
  },
  name: "LookupReg",
  components: {
    LookupVerify
  }
}
</script>

<style scoped>
.col.registration-column {
  flex-basis: auto!important;
  flex-grow: 0!important;
}
</style>